<template>
    <div>
        <nav class="menu" :class="{ 'mobile-menu-visible': mobileMenuVisible }" style="z-index: 5;">
            <div  v-for="(datos, index) in item" :key="index">
                <div class="menuiindi" >
                <a class="menuab"  @click="toggleMenu(false,datos)"  ><b-icon :icon="datos.imag"></b-icon></a>
            </div>
            <div class="titulosmenu">
                <label class="titulos poppins-semi-bold-white-10px">{{datos.nombre}}</label>
            </div>
            </div>
            <!-- <a class="menua topl"><b-icon icon="question"></b-icon></a> -->

            <!-- Versión del Software -->
            <div class="version-container">
                <small class="version-text">v{{ appVersion }}</small>
            </div>
           
        </nav> 
     <!--   <div class="menucontainer"  :class="{ 'sidebar-1': menuOpen === datos.id }" v-for="(datos, index) in item" :key="index"> -->
        <div class="menucontainer"  :class="{ 'sidebar-1': menuOpen === true }" >
                <div class="px-3 py-2 "  >
                <!-- <b-row @click="toggleMenu(true,false)">
                    <b-col offset="10"><b-icon class="iconoclose iconospointer" pill icon="arrow-left-square"></b-icon></b-col>
                </b-row> -->

                <b-row class="tituloslider">
                    <b-col cols="10" class="nombremenuleft"><b>  {{ submenussel.nombresubmenu }} </b></b-col>
                    <b-col cols="2" @click="toggleMenu(true,false)" ><b-icon class="iconoclose iconospointer" pill icon="arrow-left-square"></b-icon></b-col>
                </b-row>
                <hr>
                <div  v-for="(submenus, subindex) in submenussel.submenu" :key="subindex"  class="contebotonmenu">
                   <b-row class="rowtitle" v-b-toggle.collapse-1>
                        <b-col cols="2"> <b-icon class="iconod"  :icon="submenus.imag"></b-icon></b-col>
                        <b-col cols="8" class="nombreboton"> <p class="mr-auto pril"><b>{{   submenus.nombre }} </b></p></b-col>
                        <!-- <b-col cols="2" ><b-icon class="downn" icon="chevron-down" ></b-icon></b-col> -->
                    </b-row>
                    <b-collapse visible v-model="isCollapsedd"  v-for="(hijo, index) in submenus.hijos" :key="index"  class="mt-2">
                        <div @click="toggleMenu(true,false)" >
                            <b-row @click="generalidades(hijo.path)" class="rowoption">
                                <b-col cols="2" class="text-center">
                                    <b-icon v-if="hijo.imag" class="iconod" :icon="hijo.imag"></b-icon>
                                </b-col>
                                <b-col cols="8" class="nombreboton">
                                    <p class="mr-auto pril"><b>{{hijo.nombre}}</b></p>
                                </b-col>
                            </b-row>
                        </div>
                    </b-collapse>
                </div>
            </div>
        </div>
        <!-- <nav aria-label="breadcrumb" class="migas">
                
                <ol class="breadcrumb">

                    <li class="breadcrumb-item subrayado" @click="toggleMenu(false,datos)"> Clientes</li>

                    <li class="breadcrumb-item active" aria-current="page">Mis solicitudes</li>
                </ol>

            </nav> -->
    </div>
    
</template>
  <script>
   import Vue from 'vue'
    import { RepositoryFactory } from "../repositories/RepositoryFactory";
    const config = RepositoryFactory.get("config");

  export default {
    data() {
      return {
        idperfil:null,
        isCollapsedd: true,
        menuOpen: false,
        mobileMenuVisible: false,
        submenussel:[],
        item:[],
        // item:[{
        //         id:0,
        //         imag: "person-lines-fill",
        //         nombre:"Clientes",
        //         nombresubmenu:"Clientes",
        //         submenu:[{
        //             imag: "person-lines-fill",
        //             nombre:"Clientes",
        //             hijos:[{
        //                 nombre:"Mis solicitudes",
        //                 path: 'mis-solicitudes'
        //             },
        //             {
        //                 nombre:"Creación de solicitudes",
        //                 path: 'clientes-mis-solicitudes'
        //             },{
        //                 nombre:"Histórico de solicitudes",
        //                 path: 'historial-solicitudes'
        //             }]
        //         },
        //        ]

                
        //     },{
        //         id:2,
        //         imag:'bag-plus',
        //         nombre:"Proveedor",
        //         nombresubmenu:"Proveedores",
        //         submenu:[{
        //             imag: "bag-plus",
        //             nombre:"Proveedores",
        //             hijos:[{
        //                 nombre:"Solicitudes generales",
        //                 path: 'proveedor-solicitudes-generales'
        //             },
        //             {
        //                 nombre:"Solicitudes especificas",
        //                 path: 'proveedor-solicitudes-especificas'
        //             },{
        //                 nombre:"Mis solicitudes",
        //                 path: 'proveedor-mis-solicitudes'
        //             },{
        //                 nombre:"Histórico de solicitudes",
        //                 path: 'proveedor-historial-solicitudes'
        //             },{
        //                 nombre:"Solicitudes de retiro",
        //                 path: 'proveedor-solicitud-retiro'
        //             }]
        //         },
        //        ]
        //     },{
        //         id:1,
        //         imag:'people',
        //         nombre:"Prestador",
        //         nombresubmenu:"Prestadores",
        //         submenu:[{
        //             imag: "people",
        //             nombre:"Prestadores",
        //             hijos:[{
        //                 nombre:"Repcepción solicitudes",
        //                 path: 'prestador-recepcion-solicitudes'
        //             },
        //             {
        //                 nombre:"Dashboard solicitudes",
        //                 path: 'prestador-dashboard-solicitudes'
        //             },{
        //                 nombre:"Histórico de cliente",
        //                 path: 'prestador-historico-cliente'
        //             },{
        //                 nombre:"Histórico de proveedor",
        //                 path: 'prestador-historico-proveedor'
        //             },{
        //                 nombre:"Histórico de pacientes",
        //                 path: 'prestador-historico-pacientes'
        //             }]
        //         },
        //        ]
        //     },{
        //         id:4,
        //         imag:"bar-chart",
        //         nombre:"Config",
        //         nombresubmenu:"Configuración",
        //         submenu:[{
        //             imag: "bar-chart",
        //             nombre:"Configuración",
        //             hijos:[{
        //                 nombre:"Parámetros generales",
        //                 path: 'parametros-generales'
        //             },
        //             {
        //                 nombre:"Usuarios",
        //                 path: 'registro'
        //             },{
        //                 nombre:"Perfiles",
        //                 path: 'cc'
        //             },{
        //                 nombre:"Permisos",
        //                 path: 'cc'
        //             },{
        //                 nombre:"Clientes",
        //                 path: 'cc'
        //             },{
        //                 nombre:"Proveedores",
        //                 path: 'cc'
        //             },{
        //                 nombre:"Prestadores",
        //                 path: 'cc'
        //             }]
        //         },
        //        ]
        //     },{
        //         id:3,
        //         imag:"person",
        //         nombre:"Perfil",
        //         nombresubmenu:"Perfil",
        //         submenu:[{
        //             imag: "person",
        //             nombre:"Perfil",
        //             hijos:[{
        //                 nombre:"Cambio de contraseña",
        //                 path: 'cambio-contrasena-inicio'
        //             },
        //             {
        //                 nombre:"Datos personales",
        //                 path: 'informacion-personal'
        //             },
        //             // {
        //             //     nombre:"Cerrar sesión",
        //             //     path: 'login'
        //             // }
        //         ]
        //         },
        //        ]
        //     }]
        
        
      };
    },
    computed: {
        appVersion() {
            return process.env.VUE_APP_VERSION || process.env.npm_package_version || '1.0.0';
        }
    },
    async created() {
        const token = localStorage.getItem('userToken');
       const datosUser= localStorage.getItem('user');
       const optionsitem = localStorage.getItem('optionsitem');
       console.log(optionsitem)
       this.item = optionsitem;
       const response_data = await config.datosPersonales({"token":token});
        //var datoUser=JSON.parse(datosUser);
        this.idperfil=response_data[0].id_perfil;
        await this.MenuPerfil();
        
       
    },
    mounted() {
        this.$root.$on('toggleMobileMenu', () => {
            this.mobileMenuVisible = !this.mobileMenuVisible;
        });
    },
    beforeDestroy() {
        this.$root.$off('toggleMobileMenu');
    },
    methods: {
      toggleMenu(open,datos) {
        this.submenussel = datos;
        this.menuOpen = !open;
      },
      async MenuPerfil(){
        console.log("paso");
        const response = await config.getMenuPerfil({
                "id_perfil":this.idperfil,
            });
            console.log("paso2");
            this.item=response.message.item,
        console.log("respuesta",response.message.item);
      },
    generalidades(link){
        // if (this.$route.path == link) {
            
       
        // this.$router.go("/"+link);
        // }else{
        //     this.$router.push("/"+link); 
        // }
     
        this.$router.push("/"+link).catch(err => {this.$router.go("/"+link);}); 
       // this.menuOpen = !this.menuOpen;
    }
    },
  };
  </script>
  <style>
 
  /*------------------------------*/
  .nombremenuleft{
    margin-top:1.5% !important;
  }
*{
    font-family: var(--font-family-poppins);
}
.subrayado{
    cursor: pointer !important;
    color: var(--azul-menu);
    text-decoration: underline;
  text-decoration-color: var(--azul-menu);
  z-index: 1;
 
}
.migas{
    position: absolute;
    margin-top: 8%;
    margin-left: 10%;
}
/* .regis{
    margin-top: 6%;
} */
body{
    font-family: var(--font-family-poppins);
}
  .nombreboton{
    cursor: pointer;
  }
  .titulosmenu{
    margin-left: 32%;
    text-align: center;
}
.contebotonmenu{
    margin-bottom: 5%;
}
.iconod{
    zoom: 1.5;
}
.rowtitle{
    margin-top: 2%;
    color: var(--blue-violet);
}
.rowoption{
    margin-top: 2%;
    color: var(--blue-violet); 
    padding: 3%;
    height: 37px;
}
.rowoption:hover{
    background: var(--blue-violet);
    color: #fff;
    border-radius: 8px;
    margin-left: 1%;
    margin-right: 1%;
    width: 100%;
}
.rowoption:focus{
    background: var(--blue-violet);
    color: #fff;
    border-radius: 8px;
    margin-left: 1%;
    margin-right: 1%;
}
hr{
    margin: 2% !important;
    color: var(--blue-violet) !important;
}
.tituloslider{
    padding: 9% 2%;
}
.iconoclose{
    color: var(--blue-violet);
    zoom: 1.2;
    margin-top: 37%;
    
}
.iconospointer{
cursor: pointer;
}
.b-sidebar .b-sidebar-body {
    background: var(--zircon) !important;
}
.sidebar-right{
    top: 11.3% !important;
    width: 241px !important;
}
.xquis{
    position: absolute;
    z-index: 3;
    background: var(--blue-violet);
    top: 26%;
    right: 0;
    zoom: 2;
}
ol, ul {
     padding-left: 0rem !important; 
}
.sidebar{
    background: var( --azul-menu) !important;
}
.sidebar .profile #log_out {
    background: var( --azul-menu) !important;
}
.sidebar li a {
    background: var(--blue-violet-2) !important;
}
.sidebar li a:hover {
    background: var(--menu-items-hover-color) !important;
    color: var(--blue-violet) !important;
}
.sidebar li a:hover .links_name, .sidebar li a:hover i {
    color: var(--blue-violet) !important;
}
.title {
  display: flex;
  justify-content: flex-end;
  margin: 5px;
}
.bton{
    position: absolute;
    right: 0;
    top: 14%;
    border-bottom-right-radius: 0% !important;
    border-top-right-radius: 0% !important;
}
.btonn{
    position: absolute;
    right: 240px;
    top: 2.8%;
    border-bottom-right-radius: 0% !important;
    border-top-right-radius: 0% !important;
}
.titulos{
    letter-spacing: 0;
    line-height: 5px;
    text-align: center;
    white-space: nowrap;
    margin-top: 7%;
    margin-left: -55%;
    font-size: 9px !important;
}
.menuab{
    zoom: 1.2;
    color: white;
    text-align: center;
    background-color: var(--blue-violet-2);
    border-radius: 10px;
    display: flex;
    margin-bottom: -12%;
    height: 39px;
    justify-content: flex-end;
    margin-right: 2px;
    margin-top: -64%;
    min-width: 100%;
    width: 100%;
    padding: 10.6px 10.9px;
    cursor: pointer;
}
.menuab:hover {
    background-color: white;
    color: var(--blue-violet);
}
.menuab:active{
    background-color: white;
    color: var(--blue-violet);
}
.menuab:focus{
    background-color: white;
    color: var(--blue-violet);
}
.menua {
    color: #fff;
    text-decoration: none;
    text-align: center;
    align-items: flex-end;
    background-color: var(--blue-violet-2);
    border-radius: 10px;
    display: flex;
    height: 9%;
    justify-content: flex-end;
    margin-right: 2px;
    margin-top: 2px;
    min-width: 9%;
    width: 67%;
    padding: 21% 21%;
}
.menua:hover {
    background-color: white;
    color: var(--blue-violet);
}
.menua:active{
    background-color: white;
    color: var(--blue-violet);
}
.menua:focus{
    background-color: white;
    color: var(--blue-violet);
}
.menucontainer{
  position: fixed;
  top: 10%;
  left: -250px; /* Menú inicialmente oculto fuera de la pantalla */
  width: 250px;
  height: 95%;
  background-color: #fff;
  box-shadow: 2px 0px 5px rgba(0, 0, 0, 0.2);
  transition: left 0.3s;
  z-index: 2 !important;
  overflow: auto;
  font-weight: 800;
}
.sidebar-1{
    z-index: 1 !important;
    left: 5.3% ;
    top: 9.3% !important;
}
.menu {
    position: fixed;
    justify-content: center;
    text-align: center;
    align-items: center;
    left: 0;
    z-index: 1;
    display: flex;
    padding-top: 9%;
    justify-content: space-around;
    flex-direction: column;
    height: 100vh;
    width: 5.3%;
    background: var( --azul-menu);
}
.topl{
    margin-top: 15%;
    margin-bottom: 11%;
}

/* Estilos para la versión del software */
.version-container {
    position: absolute;
    bottom: 10px;
    width: 100%;
    text-align: center;
}

.version-text {
    color: rgba(255, 255, 255, 0.7);
    font-size: 15px;
    font-weight: 400;
    writing-mode: vertical-rl;
    text-orientation: mixed;
    transform: rotate(180deg);
}

@media (max-width: 768px) {
  .menu {
    display: none;
  }
  .menu.mobile-menu-visible {
    display: flex;
    width: 60px;
    z-index: 10;
    top: 9%;
  }
  .version-container {
    display: none;
  }
}
  </style>